import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../api";
import { useAuth } from "../auth/AuthContext";
import GoogleLoginButton from "../auth/GoogleLoginButton";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();

  const submit = async (e) => {
  e.preventDefault();
  setLoading(true);

  try {
    const { data } = await api.post("/api/auth/login", { email, password });

    loginWithToken(data.token, data.user);

    // ✅ Read mode from localStorage
    const storedMode = localStorage.getItem("app_mode");

    // normalize + fallback
    const mode =
      storedMode === "legacy"
        ? "legacy"
        : storedMode === "violation"
          ? "violation"
          : storedMode === "violations-v2" || storedMode === "violation-v2"
            ? "violations-v2"
          : "websurrogate"; // default

    const target =
      mode === "legacy"
        ? "/legacy/dashboard"
        : mode === "violation"
          ? "/violations/dashboard"
          : mode === "violations-v2"
            ? "/violations-v2"
          : "/websurrogate/dashboard";

    navigate(target);
  } catch (e) {
    alert(e?.response?.data?.error || "Login failed");
  } finally {
    setLoading(false);
  }
};


  const panelImg = (process.env.PUBLIC_URL || "") + "/court8.jpg";
  const pageBg = (process.env.PUBLIC_URL || "") + "/court7.jpg";

  return (
    <div
      className="relative min-h-screen flex items-center justify-center p-4 bg-[var(--bg)] text-[var(--fg)]"
      style={{
        backgroundImage: `linear-gradient(135deg, rgba(59,130,246,0.08), rgba(99,102,241,0.08)), url(${pageBg})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-[var(--bg)]/85 backdrop-blur-sm" />

        <div className="relative z-10 w-full max-w-md md:max-w-lg grid grid-cols-1 md:[grid-template-columns:38%_62%] rounded-2xl overflow-hidden surface-card">
        <div className="relative hidden md:block md:min-h-[420px]">
          <img src={panelImg} alt="State emblem & gavel" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/25 to-black/10" />
          <div className="absolute bottom-3 left-3 right-3 bg-white/80 backdrop-blur px-3 py-1.5 rounded-md text-[11px] text-slate-700 shadow">
            Secure access · New York Courts
          </div>
        </div>

        <div className="p-5 bg-[var(--surface)] text-[var(--fg)]">
          <p className="page-kicker">Welcome</p>
          <h1 className="page-title">Sign in</h1>
          <p className="page-subtitle mt-1 mb-3">Log in to continue</p>

          <form onSubmit={submit} className="space-y-3">
            <div>
              <label className="block text-xs font-medium text-[var(--fg)] mb-1">Email</label>
              <input
                className="w-full ui-input"
                placeholder="you@example.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                autoComplete="email"
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-[var(--fg)] mb-1">Password</label>
              <input
                type="password"
                className="w-full ui-input"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
              />
            </div>

            <button
              disabled={loading}
              className="w-full ui-btn ui-btn-primary"
            >
              {loading ? "Signing in..." : "Sign in"}
            </button>
          </form>

          <div className="mt-3">
            <GoogleLoginButton
              onSuccess={({ token, user }) => {
                loginWithToken(token, user);
                navigate("/");
              }}
            />
          </div>

          <div className="flex items-center gap-2 my-3">
            <div className="h-px flex-1 bg-[var(--border)]" />
            <span className="text-[10px] uppercase text-[var(--fg-muted)] tracking-wider">or</span>
            <div className="h-px flex-1 bg-[var(--border)]" />
          </div>

          <div className="text-sm text-[var(--fg)] flex items-center justify-between">
            <Link to="/signup" className="text-[var(--accent)] hover:underline">Create account</Link>
            <Link to="/forgot" className="text-[var(--accent)] hover:underline">Forgot password?</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
